var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 22.891,
    height: 22.096,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_2:_Pain_Point_Segmentation",
    "data-name": "Stage 2: Pain Point Segmentation",
    transform: "translate(-592 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592 301.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32053",
    "data-name": "Group 32053",
    transform: "translate(595 303.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32052",
    "data-name": "Group 32052",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M20.612,3.507l-2.8,2.755,1.406,1.1-5.374,3.2.282-.26,3.33-2.912-1.349-.979,3.569-3.8Zm-5.218.8L15.886,0l1.249.575-.911,5.332-1.805-.891-.726,3.925-.1.459-.1-6.131ZM6.767,4.292a4.411,4.411,0,1,1-3.3,5.3,4.411,4.411,0,0,1,3.3-5.3h0m9.239,15.446a2.2,2.2,0,0,1-.674.87,2.987,2.987,0,0,1-1.876.555c-.183,0-.372-.014-.567-.032a14.3,14.3,0,0,1-3.131-.762l-.047-.018.111-.063a1.877,1.877,0,0,0,.68-2.567h0a1.806,1.806,0,0,0-.2-.275,1.513,1.513,0,0,1,.422.078,21.472,21.472,0,0,0,2.1.567.032.032,0,0,0,.038-.024.034.034,0,0,0-.005-.026c-.122-.2-.5-.788-.744-1.117-.054-.072-.11-.144-.165-.216-.083-.033-.257.125-.257.125a6.427,6.427,0,0,0,.488.725c-.387-.1-.888-.237-1.331-.39a1.842,1.842,0,0,0-.94-.069,1.863,1.863,0,0,0-1.974-.057,22.523,22.523,0,0,1-4.393,2.038c.038,0,.087.068.131.068.621.405,1.986-.314,4.243-1.639A1.5,1.5,0,0,1,9.2,17.4a1.555,1.555,0,0,1,.416.24,1.572,1.572,0,0,1,.35.408A1.5,1.5,0,0,1,9.431,20.1l-.006,0c-.1.06-.206.117-.308.174-.119.068-.236.132-.353.2A14,14,0,0,1,5.594,21.8a8.622,8.622,0,0,1-.884.2,6.738,6.738,0,0,1-1.051.1,4.542,4.542,0,0,1-.93-.1,3.772,3.772,0,0,1-.648-.194c-.081-.033-.161-.072-.24-.111a3.244,3.244,0,0,1-1-.792A3.9,3.9,0,0,1,0,18.354a7.107,7.107,0,0,1,.617-2.772,6.2,6.2,0,0,1,1.552-2.224,2.959,2.959,0,0,1,1.675-.75,1.49,1.49,0,0,1,.339-.041h.279c.048.047.1.093.147.138a4.8,4.8,0,0,0,5.889.4,4.854,4.854,0,0,0,.5-.393c.054-.048.1-.1.156-.147h.357a1.5,1.5,0,0,1,1.219.452c.017.018.465.482,1.033,1.159.209.251.434.527.659.822a13.549,13.549,0,0,1,1.1,1.664,4.536,4.536,0,0,1,.662,2.128,2.412,2.412,0,0,1-.188.948m-2.5-7.309.662-.164,4.559-1.243-1.3-1.474,4.845-1.977.624,1.519-3.525.939,1.535,1.6Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPoint);
export default __webpack_public_path__ + "static/media/pain-point.19e04bc9c381774339010dd6a5268141.svg";
export { ForwardRef as ReactComponent };